import { CommandType } from "../../../../common/services/cqs/CommandType";
import { KontraktCommandBase } from "../kontrakt/KontraktCommandBase";

export class UpdateKontraktNvbCommand extends KontraktCommandBase {
    readonly kompletterandeInformation: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktNvbCommand";

    constructor(avtalGuid: string, kontraktGuid: string, kompletterandeInformation: string) {
        super(avtalGuid, kontraktGuid, UpdateKontraktNvbCommand.$type, CommandType.Replace);
        this.kompletterandeInformation = kompletterandeInformation;
    }
}
